import { render, staticRenderFns } from "./Collect3.vue?vue&type=template&id=734657f9&scoped=true"
import script from "./Collect3.vue?vue&type=script&lang=js"
export * from "./Collect3.vue?vue&type=script&lang=js"
import style0 from "./Collect3.vue?vue&type=style&index=0&id=734657f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734657f9",
  null
  
)

export default component.exports